import type { TechFormEndpointDataRequest } from "../models/tech-form-section-data.models";
import { getTechFormVesselCacheKey } from "./get-tech-form-vessel-cache-key.utils";

export function getTechFormEndpointCacheKey(request: TechFormEndpointDataRequest): string {
  const vesselCacheKey = getTechFormVesselCacheKey(request);
  if (!vesselCacheKey) {
    throw new Error("A vessel identity is required to load Technical Form data");
  }

  return JSON.stringify([vesselCacheKey, request.endpoint]);
}
